export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';
export const ID = 'ID';
export const NAME = 'NAME';
export const EMAIL = 'EMAIL';
export const ROLE_ID = 'ROLE_ID';
export const PASSWORD = 'PASSWORD';
export const PASSWORD_CONFIRMATION = 'PASSWORD_CONFIRMATION';
export const CURRENT_LANG = 'CURRENT_LANG';
export const CURRENT_DIRECTION = 'CURRENT_DIRECTION';
export const CREATED_AT = 'CREATED_AT';
export const UPDATED_AT = 'UPDATED_AT';



// WEBPACK FOOTER //
// ./src/store/modules/auth/mutation-types.js